import { all, call, takeEvery, put } from 'redux-saga/effects';
import { login, forgotPassword, logout, resetPassword } from 'services/api/user-api';
import {
  LOGIN_REQUEST,
  LOGOUT_REQUEST,
  LOGOUT_REQUEST_SUCCESS,
  LOGIN_REQUEST_SUCCESS,
  LOGIN_REQUEST_FAIL,
  FORGOT_PASSWORD,
  PASSWORD_RESET,
  CLEAR_CURRENT_USER,
  GET_CURRENT_USER,
  PASSWORD_RESET_FAIL,
  PASSWORD_RESET_SUCCESS,
  FORGOT_PASSWORD_FAIL,
} from 'store/constants/action-types';

export function* loginUser(action) {
  try {
    const response = yield call(login, action.payload.user.username, action.payload.user.password);
    yield put({
      type: LOGIN_REQUEST_SUCCESS,
      payload: {
        isLoggedIn: response.success,
        hasError: false,
        errorMessage: [],
        redirect: false,
      },
    });
  } catch (error) {
    yield put({
      type: LOGIN_REQUEST_FAIL,
      payload: {
        isLoggedIn: false,
        hasError: true,
        errorMessage: error.message,
        redirect: false,
      },
    });
  }
}

export function* sendForgotPassword(action) {
  try {
    yield call(forgotPassword, action.payload);
  } catch (error) {
    yield put({
      type: FORGOT_PASSWORD_FAIL,
      payload: {
        hasError: true,
        errorMessage: error.message,
        redirect: false,
      },
    });
  }
}

export function* confirmPasswordReset(action) {
  try {
    const response = yield call(resetPassword, action.payload);

    if (response.success) {
      yield put({
        type: PASSWORD_RESET_SUCCESS,
        payload: {
          redirect: true,
          errorMessage: null,
          hasError: false,
        },
      });
    }
  } catch (error) {
    yield put({
      type: PASSWORD_RESET_FAIL,
      payload: {
        isLoggedIn: false,
        hasError: true,
        errorMessage: error.message,
        redirect: false,
      },
    });
  }
}

export function* logoutUser() {
  try {
    yield call(logout);
    yield put({
      type: LOGOUT_REQUEST_SUCCESS,
      payload: {
        isLoggedIn: false,
        hasError: false,
        messages: [],
        redirect: false,
      },
    });
    yield put({
      type: CLEAR_CURRENT_USER,
    });
  } catch (error) {
    yield put({
      type: LOGIN_REQUEST_FAIL,
      payload: {
        isLoggedIn: true,
        redirect: false,
      },
    });
  }
}

export function* loginUserFail() {
  yield put({ type: CLEAR_CURRENT_USER });
}

export function* loginUserSuccess() {
  yield put({ type: GET_CURRENT_USER });
}

export function* watchLoginUser() {
  yield takeEvery(LOGIN_REQUEST, loginUser);
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_REQUEST, logoutUser);
}

export function* watchLoginUserFail() {
  yield takeEvery(LOGIN_REQUEST_FAIL, loginUserFail);
}

export function* watchLoginUserSuccess() {
  yield takeEvery(LOGIN_REQUEST_SUCCESS, loginUserSuccess);
}

export function* watchForgotPassword() {
  yield takeEvery(FORGOT_PASSWORD, sendForgotPassword);
}

export function* watchPasswordReset() {
  yield takeEvery(PASSWORD_RESET, confirmPasswordReset);
}

export default function* loginSagas() {
  yield all([
    watchLoginUser(),
    watchLoginUserFail(),
    watchLoginUserSuccess(),
    watchForgotPassword(),
    watchLogoutUser(),
    watchPasswordReset(),
  ]);
}
